/**
 * Depending on the service, the company id can either be upper or lower case.
 * Specifically (as at 13-Apr-22) https://graphql.simplywall.st/graphql
 * returns uppercase, and https://api.simplywall.st/ lowercase.
 */
export const doesCompanyExistInWatchlist = (
  companyId?: string | null,
  keys?: string[]
): boolean =>
  typeof companyId === 'string' &&
  companyId.length > 0 &&
  Array.isArray(keys) &&
  keys.some((key) => key.toLocaleUpperCase() === companyId.toLocaleUpperCase());
